// extracted by mini-css-extract-plugin
export var navbarSubLink = "L_gb d_gb d_f4 d_0 d_cc d_dm d_bs d_bT";
export var menuLink = "L_vk d_f0 d_dB";
export var subPageLink = "L_gf d_gf";
export var burger = "L_wY";
export var sublinkSize = "L_wZ";
export var linkSize = "L_w0";
export var Link = "L_s2 x_s2 x_sf x_sz";